import type { ThemeConfig } from "antd";

export const appTheme: ThemeConfig = {
  zeroRuntime: true,
  cssVar: {},
  token: {
    colorPrimary: "#5392C8",
    colorLink: "#226C9F",
  },
  components: {
    Button: {
      colorPrimary: "#004472", // Blue 9
      colorPrimaryHover: "#1A5C8F", // Blue 8
      colorPrimaryActive: "#033051", // Blue 10

      primaryColor: "#FFFFFF",
      // primaryShadow: "0 2px 0 rgba(0, 68, 114, 0.12)",
    },
  },
};
